import React from 'react';
import { GameCommerceFields, OfferForm, emptyOffers } from './GameCommerceFields';

export interface EditionForm {
  id?: number;
  name: string;
  description: string;
  price: string;
  purchaseOffers: OfferForm[];
}

export const emptyEdition = (): EditionForm => ({
  name: '', description: '', price: '', purchaseOffers: emptyOffers(),
});

export const GameEditionsFields = ({ editions, playStationStore, onChange }: {
  editions: EditionForm[];
  playStationStore: boolean;
  onChange: (editions: EditionForm[]) => void;
}) => {
  const update = (index: number, patch: Partial<EditionForm>) =>
    onChange(editions.map((edition, i) => i === index ? { ...edition, ...patch } : edition));

  return (
    <section className="space-y-4 rounded-2xl border border-gray-200 bg-gray-50/60 p-4 sm:p-5">
      <div className="flex items-start justify-between gap-4">
        <div><h3 className="text-sm font-semibold text-gray-900">Издания</h3><p className="mt-1 text-xs text-gray-500">Standard, Deluxe, Ultimate и другие версии игры.</p></div>
        <button type="button" onClick={() => onChange([...editions, emptyEdition()])} className="shrink-0 rounded-xl bg-gray-900 px-3 py-2 text-xs font-medium text-white hover:bg-gray-800">+ Добавить издание</button>
      </div>
      {editions.length === 0 && <p className="rounded-xl border border-dashed border-gray-200 bg-white px-4 py-5 text-center text-sm text-gray-400">Издания ещё не добавлены</p>}
      {editions.map((edition, index) => (
        <div key={edition.id ?? `new-${index}`} className="space-y-4 rounded-2xl border border-gray-200 bg-white p-4">
          <div className="flex justify-between gap-3"><h4 className="text-sm font-semibold text-gray-800">Издание {index + 1}</h4><button type="button" onClick={() => onChange(editions.filter((_, i) => i !== index))} className="text-xs font-medium text-red-600 hover:text-red-700">Удалить</button></div>
          <div className="grid gap-4 sm:grid-cols-2">
            <label><span className="mb-1 block text-xs font-medium text-gray-600">Название</span><input value={edition.name} onChange={e => update(index, { name: e.target.value })} placeholder="Deluxe Edition" className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-900 caret-gray-900 outline-none placeholder:text-gray-400 focus:border-gray-400 focus:bg-white" /></label>
            <label><span className="mb-1 block text-xs font-medium text-gray-600">Базовая цена</span><input inputMode="decimal" value={edition.price} onChange={e => update(index, { price: e.target.value })} placeholder="Цена, ₽" className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-900 caret-gray-900 outline-none placeholder:text-gray-400 focus:border-gray-400 focus:bg-white" /></label>
            <label className="sm:col-span-2"><span className="mb-1 block text-xs font-medium text-gray-600">Описание</span><textarea value={edition.description} onChange={e => update(index, { description: e.target.value })} rows={2} placeholder="Что входит в издание" className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-900 caret-gray-900 outline-none placeholder:text-gray-400 focus:border-gray-400 focus:bg-white" /></label>
          </div>
          {playStationStore && <GameCommerceFields family="PlayStation" store="PlayStationStore" offers={edition.purchaseOffers} onFamilyChange={() => {}} onStoreChange={() => {}} onOffersChange={purchaseOffers => update(index, { purchaseOffers })} compact />}
        </div>
      ))}
    </section>
  );
};
